import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      name: 'Home',
      path: '/',
      component: require('../views/Home.vue')
    },
    {
      name: 'Mobile',
      path: '/',
      component: require('../views/Mobile.vue')
    },
    {
      name: 'Login',
      path: '/login',
      component: require('../views/auth/Login')
    },
    {
      path: '*',
      redirect: '/'
    },
    {
      name: 'Admin',
      path: '/mod',
      // meta: { auth: true },
      component: require('../views/dashboard/Index.vue')
    },
    {
      name: 'AdminChannel',
      path: '/mod/:channel',
      // meta: { auth: true },
      component: require('../views/dashboard/Index.vue')
    },
    {
      name: 'Podcast',
      path: '/podcast',
      // meta: { auth: true },
      component: require('../views/dashboard/Podcasts.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./resources/assets/js/router/index.js